import React, { useEffect, useRef, useState } from "react";
import {
  ThinDropdownWithSearch,
  ThinTextField,
} from "../common/GeneralComponent";

import { useSelector, useDispatch } from "react-redux";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";
import { fetchData } from "../../utils/functions";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import InformationPanel from "./InformationPanel";
import HouseListing from "./HouseListing";
import Education from "./Education";
import Housting from "./Housting";
import Drainage from "./Drainage";
import Assets from "./Assets";
import TransportUsage from "./TransportUsage";
import Expenditure from "./Expenditure";
import ExpendetureNonFood from "./ExpenditureNonFood";
import EditHouseholdIncome from "./HouseholdIncome";
import EditSocialTransfers from "./EditSocialTransfers";
import EditHouseholdDebt from "./EditHouseholdDebt";
import EditHealthStatus from "./EditHealthStatus";
import Employment from "./Employment";
import EditVaccinationAndMortality from "./EditVaccinationAndMortality";
import EditHouseholdDeath from "./EditHouseholdDeath";
import EditHouseholdFinancial from "./EditHouseholdFinancial";

const EditHouse = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user: loggedInUser } = useSelector((state) => state.auth);
  const permission = loggedInUser?.user_permissions || [];

  const tabs = [
    {
      name: "Household Information",
      permission: "household-information-update",
    },
    { name: "Household Listing", permission: "household-listing-update" },
    { name: "Education", permission: "household-education-update" },
    {
      name: "Employment And Occupation",
      permission: "household-employement-update",
    },
    {
      name: "Vaccination Status",
      permission: "household-child-vaccination-treatment-update",
    },
    { name: "Housing", permission: "household-housing-update" },
    { name: "Drainage", permission: "household-drainage-update" },
    { name: "Household Assets", permission: "household-assets-update" },
    { name: "Transport Use", permission: "household-transport-update" },
    { name: "Household Income", permission: "household-income-update" },
    {
      name: "Social Transfers",
      permission: "household-social-transport-update",
    },
    {
      name: "Household Expenditure: Food Items",
      permission: "household-food-expenditure-update",
    },
    {
      name: "Expenditure (Non Food During The Year)",
      permission: "household-non-food-expenditure-update",
    },
    { name: "Household Debt", permission: "household-debt-update" },
    { name: "Health Status", permission: "household-health-treatment-update" },
    { name: "Mortality Report", permission: "household-report-update" },
    { name: "Financial Services", permission: "household-financial-update" },
  ];

  const allowedTabs = tabs.filter((t) => permission.includes(t.permission));
  const [activeTab, setActiveTab] = useState(allowedTabs[0]?.name || "");
  const [visitedTabs, setVisitedTabs] = useState([]);

  useEffect(() => {
    if (activeTab) setVisitedTabs((prev) => (prev.includes(activeTab) ? prev : [...prev, activeTab]));
  }, [activeTab]);

  const scrollRef = useRef(null);
  const [isLeftClicked, setIsLeftClicked] = useState(false);
  const [isRightClicked, setIsRightClicked] = useState(false);

  const [value, setValue] = useState(dayjs());
  const [loading, setLoading] = useState(true);
  const [houseHoldInfo, setHouseHoldInfo] = useState(null);

  const [houseHoldListings, setHouseHoldListings] = useState([]);
  const [houseHoldHousing, setHouseHoldHousing] = useState(null);
  const [houseHoldDrainage, setHouseHoldDrainage] = useState(null);
  const [houseHoldAssets, setHouseHoldAssets] = useState(null);
  const [transportUsage, setTransportUsage] = useState([]);

  const [householdFoodExpenditure, setHouseholdFoodExpendention] =
    useState(null);
  const [householdNonFoodExpenditure, setHouseholdNonFoodExpendention] =
    useState(null);
  const [householdIncome, setEditHouseholdIncome] = useState([]);
  const [householdeditSocialTransfer, sethouseholdeditSocialTransfer] =
    useState([]);
  const [householdDebt, sethouseholdDebt] = useState([]);
  const [HealthStatus, setHealthStatus] = useState(null);
  const [householdChildVaccination, setHouseholdChildVaccination] = useState(
    []
  );
  const [householdDeath, setHouseholdDeath] = useState(null);
  const [householdFinancial, setHouseholdFinancial] = useState(null);

  const [DqaApproved, setIsDqaApproved] = useState(false);
  const [DqaRejected, setIsDqaRejected] = useState(false);

  // Fetch household data
  const fetchHouseHold = async () => {
    try {
      setLoading(true);
      const response = await fetchData(
        `householdinformation/${id}`,
        "GET",
        null,
        {},
        {},
        navigate,
        "/provinces",
        dispatch
      );

      const data = response?.data;
      if (data) {
        setHouseHoldInfo(data.household_information ?? null);
        setHouseHoldHousing(data.household_housing ?? null);
        setHouseHoldDrainage(data.household_drainage ?? null);
        setHouseHoldAssets(data.household_assets ?? null);
        setHouseHoldListings(data.household_listings ?? []);
        setTransportUsage(data.household_transport_use ?? []);
        setEditHouseholdIncome(data.household_income ?? []);
        sethouseholdeditSocialTransfer(data.household_social_transfer ?? []);
        setHealthStatus(data.household_health_treatment_location ?? null);
        setHouseholdChildVaccination(data.household_child_vaccination ?? []);
        setHouseholdDeath(data.household_death ?? null);
        setHouseholdFinancial(data.household_financial ?? null);
        setHouseholdFoodExpendention(data.household_food_expenditure ?? null);
        setHouseholdNonFoodExpendention(
          data.household_non_food_expenditure ?? null
        );
        sethouseholdDebt(data.household_debt ?? null);

        // DQA approval makes the record read-only, for every survey type
        const dqa = Number(data.household_information?.verified_from_dqa);
        setIsDqaApproved(dqa === 1);
        setIsDqaRejected(dqa === 2);
      }
    } catch (error) {
      console.error("Error fetching household data:", error);
      toast.error("Failed to load household data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHouseHold();
  }, [id]);

  const scrollTabs = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === "left" ? -200 : 200;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
      if (direction === "left") {
        setIsLeftClicked(true);
        setTimeout(() => setIsLeftClicked(false), 200);
      } else {
        setIsRightClicked(true);
        setTimeout(() => setIsRightClicked(false), 200);
      }
    }
  };

  if (loading) {
    return (
      <div>
        <h1 className="text-[1.475rem] text-black font-bold">
          Edit Household Information
        </h1>
        <div className="flex justify-center items-center h-64 mt-6">
          <div className="text-lg text-gray-600">Loading household data...</div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h1 className="text-[1.475rem] text-black font-bold">
        Edit Household Information
      </h1>

      <div className="mt-6">
        {/* Tabs Navigation */}
        <div className="flex items-center rounded-t-lg bg-[#fdf5ec] relative">
          <button
            onClick={() => scrollTabs("left")}
            className={`text-xl px-4 py-2 font-bold ${
              isLeftClicked ? "bg-[#caa316] text-white" : "text-black"
            }`}
          >
            «
          </button>

          <div
            ref={scrollRef}
            className="flex gap-4 overflow-hidden scrollbar-hide"
          >
            {/* {allowedTabs.map((tab) => {
              // MODIFIED: When DQA rejects, unlock all tabs
              const isLocked = DqaRejected
                ? false
                : (houseHoldInfo?.start_interview === false ||
                    !(
                      houseHoldInfo?.result_of_interview ===
                        "Ongoing/ Continue" ||
                      houseHoldInfo?.result_of_interview === "Completed"
                    )) &&
                  tab.name !== "Household Information";

              return (
                <button
                  key={tab.name}
                  onClick={() => {
                    if (!isLocked) setActiveTab(tab.name);
                    else
                      toast.error(
                        "Interview not started yet. You cannot open this tab.",
                      );
                  }}
                  className={`px-10 py-2 font-semibold whitespace-nowrap 
                    ${
                      activeTab === tab.name
                        ? "bg-[#caa316] text-white"
                        : !DqaApproved || DqaRejected
                          ? "text-gray-400 cursor-not-allowed"
                          : isLocked
                            ? "text-gray-400 cursor-not-allowed"
                            : "text-black"
                    }
                  `}
                  style={{
                    borderTopLeftRadius: "13px",
                    borderTopRightRadius: "30px",
                  }}
                  disabled={!DqaApproved || DqaRejected || isLocked}
                >
                  {tab.name}
                </button>
              );
            })} */}
            {allowedTabs.map((tab) => {
              const interviewStarted =
                houseHoldInfo?.start_interview === 1 ||
                houseHoldInfo?.start_interview === true;

              const validResult =
                houseHoldInfo?.result_of_interview === "Ongoing/ Continue" ||
                houseHoldInfo?.result_of_interview === "Completed";

              const isLocked =
                (!interviewStarted || !validResult) &&
                tab.name !== "Household Information";

              return (
                <button
                  key={tab.name}
                  onClick={() => {
                    if (!isLocked) {
                      setActiveTab(tab.name);
                    } else {
                      toast.error(
                        "This tab is only available when Result of Interview is 'Ongoing/ Continue' or 'Completed'.",
                      );
                    }
                  }}
                  className={`px-10 py-2 font-semibold whitespace-nowrap ${
                    activeTab === tab.name
                      ? "bg-[#caa316] text-white"
                      : isLocked
                        ? "text-gray-400 cursor-not-allowed"
                        : "text-black"
                  }`}
                  style={{
                    borderTopLeftRadius: "13px",
                    borderTopRightRadius: "30px",
                  }}
                  disabled={isLocked}
                >
                  {tab.name}
                </button>
              );
            })}
          </div>

          <button
            onClick={() => scrollTabs("right")}
            className={`ml-auto text-xl px-4 py-2 font-bold ${
              isRightClicked ? "bg-[#caa316] text-white" : "text-black"
            }`}
          >
            »
          </button>
        </div>

        {/* Tab Content */}
        <div className="bg-white rounded-b-lg shadow-md p-6">
          {visitedTabs.includes("Household Information") && (
            <div className={activeTab === "Household Information" ? "" : "hidden"}>
              <InformationPanel
                houseHoldInfo={houseHoldInfo}
                value={value}
                setValue={setValue}
                DqaApproved={DqaApproved}
                DqaRejected={DqaRejected}
              />
            </div>
          )}
          {visitedTabs.includes("Household Listing") && (
            <div className={activeTab === "Household Listing" ? "" : "hidden"}>
              <HouseListing
                houseHoldListings={houseHoldListings}
                DqaApproved={DqaApproved}
                DqaRejected={DqaRejected}
              />
            </div>
          )}
          {visitedTabs.includes("Education") && (
            <div className={activeTab === "Education" ? "" : "hidden"}>
              <Education
                household_listings={houseHoldListings}
                DqaApproved={DqaApproved}
                DqaRejected={DqaRejected}
              />
            </div>
          )}
          {visitedTabs.includes("Housing") && (
            <div className={activeTab === "Housing" ? "" : "hidden"}>
              <Housting
                houseHoldHousing={houseHoldHousing}
                DqaApproved={DqaApproved}
                DqaRejected={DqaRejected}
              />
            </div>
          )}
          {visitedTabs.includes("Drainage") && (
            <div className={activeTab === "Drainage" ? "" : "hidden"}>
              <Drainage
                houseHoldDrainage={houseHoldDrainage}
                DqaApproved={DqaApproved}
                DqaRejected={DqaRejected}
              />
            </div>
          )}
          {visitedTabs.includes("Household Assets") && (
            <div className={activeTab === "Household Assets" ? "" : "hidden"}>
              <Assets
                AssetsList={houseHoldAssets}
                DqaApproved={DqaApproved}
                DqaRejected={DqaRejected}
              />
            </div>
          )}
          {visitedTabs.includes("Employment And Occupation") && (
            <div className={activeTab === "Employment And Occupation" ? "" : "hidden"}>
              <Employment
                household_listings={houseHoldListings}
                DqaApproved={DqaApproved}
                DqaRejected={DqaRejected}
              />
            </div>
          )}
          {visitedTabs.includes("Transport Use") && (
            <div className={activeTab === "Transport Use" ? "" : "hidden"}>
              <TransportUsage
                transportUsageList={transportUsage}
                DqaApproved={DqaApproved}
                DqaRejected={DqaRejected}
              />
            </div>
          )}
          {visitedTabs.includes("Household Expenditure: Food Items") && (
            <div className={activeTab === "Household Expenditure: Food Items" ? "" : "hidden"}>
              <Expenditure
                householdExpenditure={householdFoodExpenditure}
                DqaApproved={DqaApproved}
                DqaRejected={DqaRejected}
              />
            </div>
          )}
          {visitedTabs.includes("Expenditure (Non Food During The Year)") && (
            <div className={activeTab === "Expenditure (Non Food During The Year)" ? "" : "hidden"}>
              <ExpendetureNonFood
                householdNonFoodList={householdNonFoodExpenditure}
                DqaApproved={DqaApproved}
                DqaRejected={DqaRejected}
              />
            </div>
          )}
          {visitedTabs.includes("Household Income") && (
            <div className={activeTab === "Household Income" ? "" : "hidden"}>
              <EditHouseholdIncome
                householdIncome={householdIncome}
                DqaApproved={DqaApproved}
                DqaRejected={DqaRejected}
              />
            </div>
          )}
          {visitedTabs.includes("Social Transfers") && (
            <div className={activeTab === "Social Transfers" ? "" : "hidden"}>
              <EditSocialTransfers
                socialTransfersData={householdeditSocialTransfer}
                DqaApproved={DqaApproved}
                DqaRejected={DqaRejected}
              />
            </div>
          )}
          {visitedTabs.includes("Household Debt") && (
            <div className={activeTab === "Household Debt" ? "" : "hidden"}>
              <EditHouseholdDebt
                householdDebt={householdDebt}
                DqaApproved={DqaApproved}
                DqaRejected={DqaRejected}
              />
            </div>
          )}
          {visitedTabs.includes("Health Status") && (
            <div className={activeTab === "Health Status" ? "" : "hidden"}>
              <EditHealthStatus
                healthStatus={HealthStatus}
                householdId={id}
                DqaApproved={DqaApproved}
                DqaRejected={DqaRejected}
              />
            </div>
          )}
          {visitedTabs.includes("Vaccination Status") && (
            <div className={activeTab === "Vaccination Status" ? "" : "hidden"}>
              <EditVaccinationAndMortality
                vaccinationData={householdChildVaccination}
                mortalityData={householdDeath}
                householdListings={houseHoldListings}
                DqaApproved={DqaApproved}
                DqaRejected={DqaRejected}
              />
            </div>
          )}
          {visitedTabs.includes("Mortality Report") && (
            <div className={activeTab === "Mortality Report" ? "" : "hidden"}>
              <EditHouseholdDeath
                mortalityData={householdDeath}
                householdListings={houseHoldListings}
                DqaApproved={DqaApproved}
                DqaRejected={DqaRejected}
              />
            </div>
          )}
          {visitedTabs.includes("Financial Services") && (
            <div className={activeTab === "Financial Services" ? "" : "hidden"}>
              <EditHouseholdFinancial
                householdFinancial={householdFinancial}
                DqaApproved={DqaApproved}
                DqaRejected={DqaRejected}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditHouse;
